import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { MESSAGE_CONTENT_TYPE_ATTRIBUTE, MessageContentType } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';

import { MessageLayout } from '../../MessageLayout/MessageLayout';
import Header from '../MediaBubble/Header';
import StatusBar from '../components/StatusBar';
import { ThreadButton } from '../components/ThreadButton/ThreadButton';
import styles from './StreamBubble.styles.m.css';

export const StreamBubble = observer((props) => {
  const { message, children, className, messageViewPageType, isView } = props;
  const { comment } = message.renderPayload;

  const isShowForward = Boolean(message.forward && !message.isSavedMessagesLeft);

  const isExistHeader = Boolean(
    message.isSenderNameShow || message.repliedMessage || message.quote || isShowForward
  );

  return (
    <MessageLayout
      message={message}
      className={classNames(styles.bubble, className)}
      containerClassName={styles.container}
      messageViewPageType={messageViewPageType}
      isView={isView}
    >
      {isExistHeader && (
        <Header
          message={message}
          isShowForward={isShowForward}
        />
      )}
      <div className={styles.content}>
        {children}
        {!comment && (
          <StatusBar
            className={styles.statusBar}
            message={message}
            viewsClassName={styles.views}
            showEditIcon={false}
          />
        )}
      </div>
      {comment && comment.length && (
        <div className={styles.comment}>
          <div
            className={styles.commentText}
            {...{ [MESSAGE_CONTENT_TYPE_ATTRIBUTE]: MessageContentType.Text }}
          >
            <QuotedSelectionHighlight
              highlightedText={message.highlightedText}
              originalText={comment}
              groupId={message.groupId}
            >
              <TextRenderer
                userMentions={message.payload.userMentions}
                keyWords={message.payload.keyWords}
              >
                {comment}
              </TextRenderer>
            </QuotedSelectionHighlight>
          </div>
          <StatusBar
            message={message}
            className={styles.commentedStatusBar}
            showEditIcon={false}
          />
        </div>
      )}
      <ThreadButton message={message} />
    </MessageLayout>
  );
});
